// extracted by mini-css-extract-plugin
module.exports =  {"root":"NWQ3SBzGBOuuTBSdMgHh","creditsValue":"Vj7O9ZU1CCzmJWLd8KL9","coinIcon":"lfQVVcBxIMIa44XFWkXv"};